import $http from './index.js';
export const GetMatchList = (data) => {
    return $http.post('api/Match/GetMatchList', data)
    // return $http.get('http://jsonplaceholder.typicode.com/posts',data)
}

export const GetJudgesReformSubmit = (request) => {
    return $http.post('api/RegistrationForm/GetJudgesReformSubmit', request)
}